import { computed, ComputedRef } from 'vue-demi';
import identity from './../../store/modules/identity/index';
import { IdentityType } from './../../enums/identity';
import { getIdentityInfo } from './../../service/index';
const useIdentityHooks = (): Record<string, ComputedRef> => {
  const identityList = computed(() => identity.getters.identityFormData.value.identityList);
  const nonFakeAccounts = computed(() =>
    identity.getters.identityFormData.value.identityList.filter(item => item.identity_type !== IdentityType.FAKE_USER),
  );
  const authCodeIdentityList = computed(() =>
    identity.getters.identityFormData.value.identityList.filter(item => item.identity_type === IdentityType.AUTH_CODE),
  );
  const ownerTikTokAccount = computed(() =>
    identity.getters.identityFormData.value.identityList.filter(item => item.identity_type === IdentityType.TT_USER),
  );
  const fakeAccount = computed(() =>
    identity.getters.identityFormData.value.identityList.filter(item => item.identity_type === IdentityType.FAKE_USER),
  );
  const curIdentity = computed(() => identity.getters.identityFormData.value.curIdentity);
  const ownedTikTokAccount = computed(() => ownerTikTokAccount.value?.[0] || {});
  const displayName = computed(() => identity.getters.identityFormData.value.displayName);
  const avatarIcon = computed(() => identity.getters.identityFormData.value.avatarIcon);
  const avatarIconUrl = computed(() => identity.getters.identityFormData.value.avatarIcon?.url || '');
  const localDisplayName = computed(() => identity.getters.identityFormData.value.localDisplayName);
  const localAvatarIcon = computed(() => identity.getters.identityFormData.value.localAvatarIcon);
  const localAvatarIconUrl = computed(() => identity.getters.identityFormData.value.localAvatarIcon?.url || '');
  const identityNotAvailable = computed(() => curIdentity?.value.available_status !== 0);
  const useTikTokIdentity = computed(() => identity.getters.identityFormData.value.useTikTokIdentity);
  const nativeVideoList = computed(() => identity.getters.identityFormData.value.nativeVideoList);
  return {
    avatarIcon,
    displayName,
    curIdentity,
    fakeAccount,
    identityList,
    avatarIconUrl,
    nativeVideoList,
    nonFakeAccounts,
    localAvatarIcon,
    localDisplayName,
    useTikTokIdentity,
    localAvatarIconUrl,
    ownerTikTokAccount,
    ownedTikTokAccount,
    authCodeIdentityList,
    identityNotAvailable,
  };
};
const verifyIdentityStatus = async (identity_type, identity_id): Promise<boolean> => {
  const identityDetail = await getIdentityInfo({ identity_type, identity_id });
  return !(identityDetail.identity_type === IdentityType.TT_USER && identityDetail.available_status !== 0);
};
export { useIdentityHooks, verifyIdentityStatus };
